import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const Dropdown = ({ items }) => {
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const toggleSubMenu = (index) => {
    setOpenSubMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <ul
      className="absolute top-full bg-white shadow-md py-2 w-48 z-10 text-sm max-h-[calc(100vh-100px)] overflow-y-auto"
      style={{ scrollbarWidth: 'none' }}>   
       {items.map((item, index) => (
      <li key={index} className="relative">
        <div
          className={`flex justify-between items-center px-4 py-2 cursor-pointer ${item.color || "hover:bg-gray-100"}`}
          onClick={() => toggleSubMenu(index)}
        >
          <Link to={item.path} className="flex-1" onClick={() => window.scrollTo(0, 0)} >
            {item.label}
          </Link>
          {item.subDropdown && (
            <span>
              {openSubMenuIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          )}
        </div>
        {item.subDropdown && openSubMenuIndex === index && (
          <ul className="bg-white shadow-md py-2 w-full max-h-48 overflow-y-auto">
            {item.subDropdown.map((subItem, subIndex) => (
              <li key={subIndex}>
                <Link
                  to={subItem.path}
                  className="block px-4 py-2 hover:bg-gray-100" // Same color for all subdropdown items
                >
                  {subItem.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
    </ul>
  );
};

export default Dropdown;
